import React from 'react';
import styled from 'styled-components';
import theme from '@/styles/theme';

interface LoadingSpinnerProps{
  color?: string;
}
const LoadingSpinner = ({ color }: LoadingSpinnerProps) => {
  const innerColor = color || theme.color.purple;
  return (
    <Spinner>
      <CircleContainer>
        <Left />
        <Right />
        <InnerCircle innerColor={innerColor} />
      </CircleContainer>

    </Spinner>
  );
};

export default LoadingSpinner;

const Spinner = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
`;

const CircleContainer = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  animation: animate 1.4s ease-in-out 0s infinite running;
  @keyframes animate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const InnerCircle = styled.div<{innerColor: string}>`
  position: absolute;
  background-color: ${({ innerColor }) => innerColor};
  width: 17px;
  height: 17px;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Left = styled.div`
  position: relative;
  width: 10px;
  height: 20px;
  border-radius: 10px 0 0 10px;
  background-color: white;
  background: linear-gradient(#ffffff80, #ffffff, #ffffff);
`;

const Right = styled.div`
  position: relative;
  width: 10px;
  height: 20px;
  border-radius: 0 10px 10px 0;
  background: linear-gradient(#ffffff90, #ffffff40, #ffffff10);
`;
